import * as R from 'ramda';
import { makeStyles } from 'tss-react/mui';
import ProductAvailabilityChip from '../../../components/Product/ProductAvailabilityChip';
import { Classification } from '../../classifications/classification.types';
import { AvailabilityEnum, DeliveryWindow } from '../../products/ProductTypes';
import { availabilityToCompactAvailability } from '../../products/utils/availability.utils';
import OrderChip from './OrderChip';

const TAGS_HEIGHT = 18;

interface OrderTagsProps {
  classification?: Classification;
  deliveryWindow?: DeliveryWindow;
  availabilities: AvailabilityEnum[];
  label?: string;
}

const useStyles = makeStyles()(() => ({
  chip: {
    height: TAGS_HEIGHT,
    flexShrink: 0,
    '&:last-child': {
      flexShrink: 1,
      minWidth: 0,
    },
  },
}));

const OrderTags = ({ classification, availabilities, deliveryWindow, label }: OrderTagsProps) => {
  const { classes } = useStyles();
  const tagAvailabilities = R.uniq(
    availabilities.map(
      (availability) => availabilityToCompactAvailability(availability) ?? availability,
    ),
  );

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        columnGap: '4px',
        overflow: 'hidden',
      }}
    >
      {deliveryWindow && deliveryWindow.name && tagAvailabilities.length >= 1 ? (
        <ProductAvailabilityChip
          availability={tagAvailabilities[0]}
          label={deliveryWindow.name}
          className={classes.chip}
        />
      ) : (
        tagAvailabilities.map((av) => (
          <ProductAvailabilityChip
            availability={av}
            key={av}
            label={label}
            className={classes.chip}
          />
        ))
      )}
      {classification && classification.name && (
        <OrderChip name={classification.name} className={classes.chip} showTooltip />
      )}
    </div>
  );
};

export default OrderTags;
